import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { setPropTypes, compose, withProps } from 'recompose'
import Select from '../../../Shared/Form/Select'

const identity = i => i

const enhance = compose(
  inject('store'),
  withProps(({ store }) => ({
    valueState: store.valueStateStore,
    uiState: store.uiStateStore
  })),
  setPropTypes({
    valueState: PropTypes.object.isRequired,
    uiState: PropTypes.object.isRequired
  }),
  observer
)

const SortingSelector = enhance(({ valueState, uiState }) => {
  const [isHydrated, setIsHydrated] = useState(false)

  useEffect(() => {
    setIsHydrated(true)
  }, [])

  const options = uiState.orderOptions || []
  const DEFAULT_VALUE = 'Newest'
  const initialValue = options.includes(DEFAULT_VALUE) ? DEFAULT_VALUE : (options[0] || DEFAULT_VALUE)
  const value = isHydrated && valueState.values.order
    ? valueState.values.order
    : initialValue

  if (!isHydrated) {
    return <div style={{ minHeight: '16px', minWidth: '180px' }} />
  }

  return (
    <Select
      id='order'
      name='order'
      label='SORT BY:'
      options={options}
      optionIdentity={identity}
      selectedOptionTemplate={identity}
      optionTemplate={identity}
      value={value}
      className='Select--noBorder Select--srp'
      optionClassName='Option Option-srp'
      onChange={val => {
        valueState.setInputValue('order', val)
        valueState.fetchDataForListings()
        valueState.getSearchInfoDebounced()
      }}
    />
  )
})

export default SortingSelector
